import React from 'react';
import './Services.css';
import { FaUsers, FaBullhorn, FaUserTie, FaEnvelope, FaLinkedin, FaSearch, FaDatabase, FaChartLine, FaListAlt } from 'react-icons/fa';
import logo from '../assets/images/logo.jpeg';

const Services = () => {
  const services = [
    {
      icon: <FaUsers />,
      title: 'Candidate Sourcing',
      description: 'Identify and engage top-tier talent through expert candidate identification and personalized outreach strategies tailored to your hiring needs.'
    },
    {
      icon: <FaBullhorn />,
      title: 'Lead Generation',
      description: 'Build a robust sales pipeline with high-quality, targeted leads that convert into loyal customers and drive revenue growth.'
    },
    {
      icon: <FaUserTie />,
      title: 'Client Hunting Leads',
      description: 'Connect with key decision-makers and influencers to accelerate your business development and close deals faster.'
    },
    {
      icon: <FaDatabase />,
      title: 'Candidate Leads',
      description: 'Access a comprehensive database of skilled professionals actively seeking new opportunities in your industry.'
    },
    {
      icon: <FaEnvelope />,
      title: 'Business and Personal Email Lists',
      description: 'Receive verified and segmented email lists designed for effective direct marketing campaigns and personalized outreach.'
    },
    {
      icon: <FaLinkedin />,
      title: 'LinkedIn Prospecting',
      description: 'Leverage LinkedIn to identify, connect, and engage with high-value prospects and key decision-makers in your target market.'
    },
    {
      icon: <FaSearch />,
      title: 'Boolean Search',
      description: 'Utilize advanced Boolean search techniques to pinpoint candidates with specific skill sets, qualifications, and experience levels.'
    },
    {
      icon: <FaChartLine />,
      title: 'Headhunting',
      description: 'Gain access to custom-built candidate lists designed to meet your precise requirements for executive and specialized roles.'
    },
    {
      icon: <FaDatabase />,
      title: 'Database Management',
      description: 'Maintain clean, organized, and up-to-date contact databases to ensure optimal CRM performance and campaign effectiveness.'
    },
    {
      icon: <FaListAlt />,
      title: 'Custom List Building',
      description: 'Get tailored prospect lists based on your specific criteria, including industry, location, company size, and job titles.'
    }
  ];

  return (
    <section className="services section" id="services">
      <div className="container">
        <div className="services-header-wrapper">
          {/* Logo on the left - positioned absolutely */}
          {/* <div className="services-logo-section">
            <img src={logo} alt="LTSS Logo" className="services-logo" />
          </div> */}

          {/* Title and subtitle centered */}
          <div className="services-header-content">
            <h2 className="section-title">Our Services</h2>
            <p className="section-subtitle">
              Comprehensive solutions designed to accelerate your growth and optimize operations.
            </p>
          </div>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;